import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/styles';
import { NAVBAR_TEST_IDS } from '@/lib/test-ids';
import styles from './MobileMenu.module.css';
interface MobileMenuToggleProps {
  onClick: () => void;
  isMobileMenuOpen: boolean;
}
export const MobileMenuToggle = t0 => {
  const $ = _c(9);
  const {
    onClick,
    isMobileMenuOpen
  } = t0;
  const t = useTranslations("Navbar");
  const t1 = isMobileMenuOpen && styles.active;
  let t2;
  if ($[0] !== t1) {
    t2 = cn("lg:hidden", t1, styles["hamburger-menu"]);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("toggle");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={styles["hamburger-menu__lines"]} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClick || $[6] !== t2 || $[7] !== t3) {
    t5 = <Button variant="primaryLink" size="none" className={t2} onClick={onClick} data-test-id={NAVBAR_TEST_IDS.MOBILE_MENU_BUTTON} aria-label={t3}>{t4}</Button>;
    $[5] = onClick;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};